<template>
  <button type="button" class="btn btn-light" @click="show = true">Add Creditcard Surcharge</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Creditcard Surcharge</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="existing-flight mb-3">
            <label for="">Add Creditcard Surcharge</label>
          </div>
          <div class="flight-data">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="">Percentage</label>
                  <div class="input-group">
                    <span class="input-group-text" id="basic-addon1">%</span>
                    <input type="number" class="form-control" v-model="order_creditcard.price">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="orderAddCreditcardSurcharge()">Add to order</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
export default {
  name: 'VariousModal',
  props: ['form', 'products'],
  data() {
    return {
      show: false,
      order_creditcard: {
        tax: null,
        qty: null,
        price: null,
      },
    }
  },
  methods: {
    orderAddCreditcardSurcharge () {
      let price = ((this.form.final_total / 100 ) * this.order_creditcard.price)

      this.form.order_lines.push({
        type: "custom",
        data: null,
        name: `Creditcard Surcharge ${this.order_creditcard.price}%`,
        price: parseFloat(price).toFixed(2),
        qty: "1",
      })

      this.show = false;
    }
  }
}
</script>

<style>

</style>
